import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { StepOverviewContainer } from './StepOverviewContainer.js';

const StepOverview = (props)=>/*#__PURE__*/ React.createElement(StepOverviewContainer, swcHelpers.extends({}, props))
;

export { StepOverview };
//# sourceMappingURL=layout.js.map
